import React from "react";
import GeneralMessage from "./GeneralMessage";

const NotImplemented = ({
  icon = "🚧",
  title = "This feature is not implemented yet.",
  message = "We're working hard to bring you this feature. Check back soon!",
}) => {
  return <GeneralMessage icon={icon} message={message} title={title} />;
};

export default NotImplemented;
